<template>
<div>
     <v-navigation-drawer
      v-model="drawer"
      app
      class="primary"
    >
      
        <v-list-item>
        <v-list-item-content>
          <v-list-item-title v-if="signedin == false" class="text-p white--text text-center">
            Welcome
          </v-list-item-title>
          <v-list-item-title v-if="signedin == true" class="text-p white--text text-center">
            Welcome <br>
             {{ this.user.displayName }}
          </v-list-item-title>
          <!-- <v-list-item-subtitle class="white--text">
            subtext
          </v-list-item-subtitle> -->
        </v-list-item-content>
      </v-list-item>

      <v-divider color="white"></v-divider>

      <v-list
        dense
        nav
      >
        <!-- <v-list-item
          v-for="item in items"
          :key="item.title"
          :to="item.to"
          class="white--text"
        >
          <v-list-item-icon >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
      <v-list
        dense
        nav
      >
      <v-list-item 
          @click="home()"
          class="white--text"
        >
          <v-list-item-icon>
            <v-icon class="white--text">mdi-home</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="signedin == false"
          class="white--text"
          @click="currentfights()"
        >
          <v-list-item-icon >
            <v-icon class="white--text">mdi-ticket</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Current Fights</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="signedin == false"
          class="white--text"
          @click="upcomingfights()"
        >
          <v-list-item-icon >
            <v-icon class="white--text">mdi-timetable</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Upcoming Fights</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
                 <v-list-item
          v-if="signedin == false"
          class="white--text"
          @click="pastfights()"
        >
          <v-list-item-icon >
            <v-icon class="white--text">mdi-history</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Past Fights</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="white--text"
          @click="login()"
          v-if="signedin == false"
        >
          <v-list-item-icon>
            <v-icon class="white--text">mdi-login-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="signedin == false"
          class="white--text"
          @click="register()"
        >
          <v-list-item-icon >
            <v-icon class="white--text">mdi-account</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Register</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="white--text"
          @click="logout()"
          v-if="signedin == true"
        >
          <v-list-item-icon >
            <v-icon class="white--text">mdi-logout-variant</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>






    </v-navigation-drawer>
      <v-app-bar
        elevation="4"
        color="black"
        height="100px"
        app
        >
        <v-app-bar-nav-icon class="primary--text ml-2" @click="drawer = !drawer">

        </v-app-bar-nav-icon>
        <v-container>
            <v-row align="center"
      justify="center">
                <v-col cols="6" sm="6" md="6" lg="6" class="secondary--text">
                    <v-img src="../../assets/africanring.jpeg" contain
                            max-width="100"
                            width="100%"
                        />
                    <!-- <v-icon color="secondary" class="mr-3">mdi-facebook</v-icon>
                    <v-icon color="secondary"  class="mr-3">mdi-instagram</v-icon>
                    info@africanring.co.za -->
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" sm="6" md="6" lg="6" class="text-right hidden-md-and-up">
                   <v-badge
                    :content="messages"
                    :value="messages"
                      color="primary"
                      overlap
                    >
                      <v-icon color="primary" large>
                        mdi-bell
                      </v-icon>
                    </v-badge>
                </v-col>
                <!-- <v-col cols="12" sm="12" md="6" lg="6"> -->
                    <!-- <v-tabs class="white--text mynav" color="#fff">
                      <v-tab class="white--text" @change="home()">Home</v-tab>
                      <v-tab class="white--text" @change="login()">Current Fights</v-tab>
                      <v-tab class="white--text" @change="regitser()">Up Ccoming fights</v-tab>
                    </v-tabs> -->
                <!-- </v-col> -->
                <v-col cols="2" class="text-right secondary--text hidden-sm-and-down">
                    <v-btn
                        v-if="signedin == false"
                        elevation="2"
                        class="primary"
                        to="/login"
                        >
                        Login
                    </v-btn>
                    <v-btn
                        v-if="signedin == true"
                        elevation="2"
                        class="primary"
                        @click="logout()"
                        >
                        Signout
                    </v-btn>
                </v-col>
            </v-row>
            
        </v-container>   
    </v-app-bar>
</div>
</template>

<script>
import firebase from 'firebase/compat/app';
import { mapGetters } from 'vuex';
export default {
    data: () => ({
        messages: 3,
        drawer: false,
        links: [
            {text: 'Home', to:'/'}
        ],
        // items: [
        //   { title: 'Home', icon: 'mdi-view-dashboard', to: '/' },
        //   { title: 'Register', icon: 'mdi-account-switch', to: '/subscribe' },
        //   { title: 'Login', icon: 'mdi-login-variant', to: '/login' },
        //   // { title: 'Register', icon: 'mdi-account-plus', to: '/register' },
        // ],
    }),
    computed:{
      ...mapGetters(['signedin', 'user'])
    },
    methods : {
      home(){
        this.$router.replace('/');
      },
      register(){
        this.$router.replace('/subscribe');
      },
      login(){
        this.$router.replace('/login');
      },
      pastfights(){
        this.$router.replace('/past-fights');
      },
      upcomingfights(){
        this.$router.replace('/upcoming-fights');
      },
      currentfights() {
        this.$router.replace('/current-fights');
      },
      logout(){
            firebase.auth().signOut().then(() => {
              let signedin = false;
              let user = {}
              let fighters = []

              this.$store.dispatch('setUser', user);
              this.$store.dispatch('setSignedIn', signedin);
              this.$store.dispatch('setsetgetallfightersNull', fighters);
              this.$router.replace('/');
            });
         },
    }
}
</script>

<style lang="sass">
.mynav 
  background-color: #000 !important
</style>